<!--
 * @Author: Latte
 * @Date: 2021-12-29 09:47:58
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-04 14:42:17
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\statisticsManagement\liveStatistics\index.vue
-->
<template>
	<div class="container">
		<div class="toolbar">
			<div class="left">
				<el-input v-model="inputValue" placeholder="请输入直播ID" prefix-icon="el-icon-search" size="mini"
					style="width: 400px" />

				<el-button :disabled="!inputValue" type="primary" size="mini" icon="el-icon-search"
					style="margin-left: 10px" @click="search()">搜索</el-button>

				<el-button :disabled="liveID === 0" type="primary" size="mini" icon="el-icon-search" @click="showAll()">
					查看所有直播观众</el-button>
			</div>

			<div class="right">
				<el-button-group>
					<el-button :type="switchName === 'all' ? 'primary' : ''" size="mini" @click="switchTo('all')">全部
					</el-button>
					<el-button :type="switchName === 'app' ? 'primary' : ''" size="mini" @click="switchTo('app')">APP 端
					</el-button>
					<el-button :type="switchName === 'h5' ? 'primary' : ''" size="mini" @click="switchTo('h5')">H5 端
					</el-button>
				</el-button-group>
			</div>
		</div>

		<el-row :gutter="20">
			<el-col :span="12">
				<el-card shadow="never">
					<div id="chart_map" />
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card shadow="never">
					<div id="chart_bar" />
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import axios from 'axios'
  import "@/utils/map/js/china.js";
	import {
		getProvinceUserData
	} from '@/api/statisticsManagement/statisticalData'

	export default {
		data() {
			return {
				liveID: 0, // 直播ID
				inputValue: '', // 搜索框内容
				chartMap: null, // 地图对象
				chartMapOption: {}, // 地图选项
				chartBar: null, // 柱状图对象
				chartBarOption: {}, // 柱状图选项
				userDataList: [], // 用户数据列表
				nameList: [], // 柱状图y值
				valueList: [], // 柱状图x值
				switchName: 'all', // 当前选中
				// loading选项
				loadingOpts: {
					text: '',
					color: '#409EFF',
					maskColor: 'rgba(255, 255, 255, 0.8)',
					zlevel: 0,
					showSpinner: true, // 是否显示旋转动画（spinner）
					spinnerRadius: 20, // 旋转动画（spinner）的半径
					lineWidth: 2 // 旋转动画（spinner）的线宽
				}
			}
		},
		async created() {
			if (this.$route.query.liveID) {
				this.inputValue = this.liveID = this.$route.query.liveID
			}
			// 区分国内与海外分布图
			// if (this.$i18n.locale === 'zh') {
			//   this.getProvinceUserData()
			// } else {
			//   this.getGlobalUserData()
			// }
			await this.getProvinceUserData()
		},
		methods: {
			/**
			 * 画地图
			 */
			drawMap() {
				const userDataList = this.userDataList
				this.chartMap = this.$echarts.init(document.getElementById('chart_map'))
				const chartMapOption = {
					title: {
						text: '全国观众分布',
						x: 'center',
						top: '20px'
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						left: 'left'
					},
					visualMap: {
						x: 'left',
						y: 'bottom',
						splitList: [{
								start: 1001,
								end: 10000
							},
							{
								start: 501,
								end: 1000
							},
							{
								start: 301,
								end: 500
							},
							{
								start: 101,
								end: 300
							},
							{
								start: 1,
								end: 100
							},
							{
								start: 0,
								end: 0
							}
						]
					},
					series: [{
						name: '观众数量',
						type: 'map',
						mapType: 'china',
						roam: false,
						label: {
							show: true
						},
						showLegendSymbol: false,
						data: userDataList
					}]
				}
				this.chartMap.setOption(chartMapOption)
				// setTimeout(() => {
				//   this.chartMap.hideLoading()
				// }, 1000)
			},
			/**
			 * 画柱状图
			 */
			drawBar() {
				this.chartBar = this.$echarts.init(document.getElementById('chart_bar'))
				this.chartBarOption = {
					title: {
						text: '观众数量排名',
						x: 'center',
						top: '20px'
					},
					grid: {
						top: '80px',
						left: '30px',
						right: '30px',
						bottom: '30px',
						containLabel: true
					},
					xAxis: {
						type: 'value'
					},
					yAxis: {
						type: 'category',
						data: this.nameList
					},
					series: [{
						type: 'bar',
						data: this.valueList,
						label: {
							show: true,
							position: 'right',
							color: 'black'
						}
					}]
				}
				this.chartBar.setOption(this.chartBarOption)
				setTimeout(() => {
					this.chartBar.hideLoading()
				}, 1000)
			},
			/**
			 * 获取全国观众统计数据
			 */
			getProvinceUserData() {
				let params = {
					liveID: this.liveID
				}
				getProvinceUserData(params).then(res => {
					this.userDataList = res.data

					// APP + H5
					this.userDataList.map(item => {
						item.value = item.count + item.countH5
					})

					// 排序
					const compare = p => (m, n) => {
						return m[p] - n[p]
					}
					this.userDataList.sort(compare('value'))

					// 获取名称列表
					this.nameList = this.userDataList.map(item => {
						return item.name
					})

					// 获取值列表
					this.valueList = this.userDataList.map(item => {
						return item.value
					})

					this.drawMap()
					this.drawBar()
				})
			},
			/**
			 * 画地图2
			 */
			drawMap2() {
				this.chartMap = this.$echarts.init(document.getElementById('chart_map'))
				this.chartMapOption = {
					title: {
						text: 'Global Audience Distribution',
						x: 'center',
						top: '20px'
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						left: 'left'
					},
					visualMap: {
						x: 'left',
						y: 'bottom',
						splitList: [{
								start: 1000000,
								end: 10000000
							},
							{
								start: 10000,
								end: 1000000
							},
							{
								start: 1000,
								end: 10000
							},
							{
								start: 100,
								end: 1000
							},
							{
								start: 10,
								end: 100
							},
							{
								start: 0,
								end: 10
							}
						]
					},
					series: [{
						name: 'Audience Count',
						type: 'map',
						mapType: 'world',
						roam: false,
						label: {
							show: false
						},
						showLegendSymbol: false,
						data: this.userDataList
					}]
				}
				this.chartMap.setOption(this.chartMapOption)
				// setTimeout(() => {
				//   this.chartMap.hideLoading()
				// }, 1000)
			},
			/**
			 * 画柱状图2
			 */
			drawBar2() {
				this.chartBar = this.$echarts.init(document.getElementById('chart_bar'))
				this.chartBarOption = {
					title: {
						text: 'Audience Ranking',
						x: 'center',
						top: '20px'
					},
					grid: {
						top: '80px',
						left: '30px',
						right: '30px',
						bottom: '30px',
						containLabel: true
					},
					xAxis: {
						type: 'value'
					},
					yAxis: {
						type: 'category',
						data: this.nameList
					},
					series: [{
						type: 'bar',
						data: this.valueList,
						label: {
							show: true,
							position: 'right',
							color: 'black'
						}
					}]
				}
				this.chartBar.setOption(this.chartBarOption)
				setTimeout(() => {
					this.chartBar.hideLoading()
				}, 1000)
			},
			/**
			 * 获取全球观众统计数据
			 */
			getGlobalUserData() {
				let params = {
					liveID: this.liveID
				}

				axios.get('http://localhost:3000/userDistribution').then(res => {
					this.userDataList = res.data
					console.log('sasas')

					// 排序
					const compare = p => (m, n) => {
						return m[p] - n[p]
					}
					this.userDataList.sort(compare('value'))

					// 获取名称列表
					this.nameList = this.userDataList.map(item => {
						return item.name
					})

					// 获取值列表
					this.valueList = this.userDataList.map(item => {
						return item.value
					})

					// 截取前20
					this.nameList = this.nameList.slice(
						this.nameList.length - 20,
						this.nameList.length
					)
					this.valueList = this.valueList.slice(
						this.valueList.length - 20,
						this.valueList.length
					)

					this.drawMap2()
					this.drawBar2()
				})
			},
			/**
			 * 切换
			 *
			 * @param value // all/app/h5
			 */
			switchTo(value) {
				this.switchName = value
				switch (value) {
					case 'all':
						this.userDataList.map(item => {
							item.value = item.count + item.countH5 // APP + H5
						})
						break
					case 'app':
						this.userDataList.map(item => {
							item.value = item.count
						})
						break
					case 'h5':
						this.userDataList.map(item => {
							item.value = item.countH5
						})
						break
				}
				// 获取名称列表
				this.nameList = this.userDataList.map(item => {
					return item.name
				})
				// 获取值列表
				this.valueList = this.userDataList.map(item => {
					return item.value
				})
				this.drawMap()
				this.drawBar()
			},
			/**
			 * 搜索
			 */
			search: _.throttle(
				function() {
					this.liveID = this.inputValue
					this.switchName = 'all'
					this.chartMap.showLoading(this.loadingOpts)
					this.chartBar.showLoading(this.loadingOpts)
					this.getProvinceUserData()
				},
				3000, {
					trailing: false
				}
			),
			/**
			 * 显示全部
			 */
			showAll() {
				this.liveID = 0
				this.switchName = 'all'
				this.chartMap.showLoading(this.loadingOpts)
				this.chartBar.showLoading(this.loadingOpts)
				this.getProvinceUserData()
			}
		}
	}
</script>

<style scoped lang="scss">
	.container {
		display: flex;
		flex-direction: column;

		.toolbar {
			display: flex;
			justify-content: space-between;
			margin: 10px 0 20px;
		}

		#chart_map,
		#chart_bar {
			width: 100%;
			height: 720px;
		}
	}
</style>
